import React, { useEffect } from "react";
import {
  useGetAddVisitorsQuery,
  useGetVisitorsQuery,
} from "../../../redux/services/internal/apiHome";

const VisitorsCount = () => {
  const {
    data: visitors,
    isLoading: visitorsLoading,
    isError: visitorsError,
  } = useGetVisitorsQuery();
  const { refetch: addVisitor } = useGetAddVisitorsQuery();

  useEffect(() => {
    addVisitor();
  }, [addVisitor]);
  return (
    <p>
      Visitors:
      <span>
        {visitors && visitors?.data > 0
          ? // ? visitors.data.toString().padStart(6, "0")
            visitors.data.toString()
          : "No Data Found"}
      </span>
    </p>
  );
};

export default VisitorsCount;
